import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Pause from "../common/Pause";
import { getTargetGroupDetails } from "../utils";

const TargetGroupPaused = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, updatedBy, updatedAt } = getTargetGroupDetails(log);
  return <Pause name={name} updatedAt={updatedAt} updatedBy={updatedBy} />;
};

export default TargetGroupPaused;
